import { render, staticRenderFns } from "./education_info.vue?vue&type=template&id=89b7dfd0&scoped=true&"
import script from "./education_info.vue?vue&type=script&lang=js&"
export * from "./education_info.vue?vue&type=script&lang=js&"
import style0 from "./education_info.vue?vue&type=style&index=0&id=89b7dfd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b7dfd0",
  null
  
)

export default component.exports